<div *uiModernContext
     class="inherited-checkbox-outer-container">
    <div class="inherited-checkbox-outer-container">
        <mat-checkbox [(ngModel)]="includeInheritedUsers"
                      data-cy="folder-grid-include-inherited">
            {{'folder_users_include_inherited' | translate}}
        </mat-checkbox>
    </div>
</div>

<ui-grid [data]="processedData$ | async"
         [loading]="loading$ | async"
         [selectable]="false"
         data-cy="folder-assigned-users-grid">

    <ui-grid-header [search]="true">
        <ui-header-button type="main">
            <ng-template>
                <ui-action-expander *ngIf="isWindowsAuthenticationEnabled; else assignLocalUser"
                                    [tooltipOpen]="'folder_users_assign_user' | translate"
                                    [tooltipClose]="'modal_action_close' | translate"
                                    [folderId]="folder.id"
                                    [uiAuthorizeDisable]="'Units.Edit & Roles.View | SubFolders.Edit & Roles.View'">
                    <button [matTooltip]="'folder_users_assign_ad_user' | translate"
                            [uiClickTrack]="'Action: Assign AD user to folder'"
                            (click)="openAssignUserModal(null, false)"
                            mat-mini-fab
                            color="primary"
                            data-cy="assign-ad-user-button"
                            type="button">
                        <mat-icon>group_add</mat-icon>
                    </button>

                    <ng-container *ngTemplateOutlet="assignLocalUser"></ng-container>
                </ui-action-expander>

                <ng-template #assignLocalUser>
                    <button [uiAuthorizeDisable]="'Units.Edit & Roles.View | SubFolders.Edit & Roles.View'"
                            [folderId]="folder.id"
                            [matTooltip]="(
                                isWindowsAuthenticationEnabled
                                ? 'folder_users_assign_local_user'
                                : 'folder_users_assign_user'
                            ) | translate"
                            [uiClickTrack]="'Action: Assign user to folder'"
                            (click)="openAssignUserModal(null, true)"
                            mat-mini-fab
                            color="primary"
                            data-cy="assign-user-button"
                            type="button">
                        <mat-icon>{{ isWindowsAuthenticationEnabled ? 'person_add' : 'add' }}</mat-icon>
                    </button>
                </ng-template>
            </ng-template>
        </ui-header-button>
    </ui-grid-header>

    <ui-grid-column [sortable]="true"
                    [searchable]="true"
                    [title]="'folder_users_grid_username' | translate"
                    width="30%"
                    property="user.userName">
    </ui-grid-column>

    <ui-grid-column [title]="'folder_users_grid_roles' | translate"
                    width="70%"
                    property="roles">
        <ng-template let-entry="data">
            <div [matTooltip]="entry.rolesInheritance">
                {{ entry.rolesInheritance }}
            </div>
        </ng-template>
    </ui-grid-column>

    <ui-grid-row-action>
        <ng-template let-entry="data">
            <ng-container *ngIf="!entry.user.isInherited">
                <ng-container *ngIf="folder.rolesAssignment === RolesAssignment.CustomRoles;
                                     else fixedRolesActions">
                    <ng-container *ngIf="hasPermissionsToOpenMenu$ | async">
                        <button [matMenuTriggerFor]="assignedUserMenu"
                                [matTooltip]="'global_more_actions_tooltip' | translate"
                                mat-icon-button
                                data-cy="assigned-user-menu"
                                type="button">
                            <mat-icon svgIcon="uipath:More"></mat-icon>
                        </button>
                        <mat-menu #assignedUserMenu="matMenu">
                            <button [uiAuthorizeDisable]="'Units.Edit & Roles.View | SubFolders.Edit & Roles.View'"
                                    [folderId]="folder.id"
                                    (click)="openAssignUserModal(entry)"
                                    mat-menu-item
                                    data-cy="edit-user-roles"
                                    type="button">
                                <mat-icon svgIcon="uipath:Edit"></mat-icon>
                                {{ 'folders_assigned_user_edit_roles' | translate }}
                            </button>
                            <button [uiAuthorizeDisable]="'Units.Edit | SubFolders.Edit'"
                                    [folderId]="folder.id"
                                    (click)="unassignUser(entry)"
                                    mat-menu-item
                                    color="warn"
                                    data-cy="unassign-user"
                                    type="button">
                                <mat-icon svgIcon="uipath:Delete"></mat-icon>
                                {{ 'folders_assigned_user_remove' | translate }}
                            </button>
                        </mat-menu>
                    </ng-container>
                </ng-container>

                <ng-template #fixedRolesActions>
                    <button [uiAuthorizeDisable]="'Units.Edit | SubFolders.Edit'"
                            [folderId]="folder.id"
                            [matTooltip]="'folder_users_unassign_user' | translate"
                            (click)="unassignUser(entry)"
                            mat-icon-button
                            color="warn"
                            data-cy="unassign-user"
                            type="button">
                        <mat-icon svgIcon="uipath:Delete"></mat-icon>
                    </button>
                </ng-template>
            </ng-container>
        </ng-template>
    </ui-grid-row-action>

    <ui-grid-footer [length]="total$ | async"
                    [pageSize]="pageSize"
                    [pageSizes]="pageSizes">
    </ui-grid-footer>
</ui-grid>
